import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { TextPrettyPipe } from '../../pipes/text-pretty.pipe';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { DataManagementComponent } from './data-management.component';
import { DataConfigurationComponent } from './components/data-configuration/data-configuration.component';
import { DataPullConfigurationComponent } from './components/data-pull-configuration/data-pull-configuration.component';
import { DataPreviewComponent } from './components/data-preview/data-preview.component';
import { DataManagementRoutingModule } from './data-management-routing.module';
import { FormBuilderComponent } from 'src/app/components/form-buider/form-buider.component';
import {
  DialogAnimationsDialog,
  StoringDataComponent,
} from './components/storing-data/storing-data.component';
import { DataManagementCardComponent } from 'src/app/components/data-management-card/data-management-card.component';
import { ConfigureDataSourceComponent } from './components/configure-data-source/configure-data-source.component';
import { AvailableDataSourcesComponent } from './components/available-data-sources/available-data-sources.component';
import { MaterialModule } from 'src/app/material/material.module';
import { NamingSizePipe } from 'src/app/pipes/naming-size.pipe';
import { UploadFilesComponent } from './components/upload-files/upload-files.component';
import { TimezonePipe } from 'src/app/pipes/timezone.pipe';
import { ShowWebSocketResponseComponent } from './show-web-socket-response/show-web-socket-response.component';

@NgModule({
  declarations: [
    DataManagementComponent,
    ConfigureDataSourceComponent,
    DataConfigurationComponent,
    DataPullConfigurationComponent,
    DataPreviewComponent,
    StoringDataComponent,
    DialogAnimationsDialog,
    AvailableDataSourcesComponent,
    UploadFilesComponent,
    ShowWebSocketResponseComponent,
  ],
  imports: [
    CommonModule,
    MaterialModule,
    RouterModule,
    TextPrettyPipe,
    DatePipe,
    FormsModule,
    ReactiveFormsModule,
    DataManagementRoutingModule,
    FormBuilderComponent,
    DataManagementCardComponent,
    NamingSizePipe,
    TimezonePipe,
  ],

  exports: [
    DataManagementComponent,
    ConfigureDataSourceComponent,
    DataConfigurationComponent,
    DataPreviewComponent,
    DataPullConfigurationComponent,
    AvailableDataSourcesComponent,
  ],
  providers: [DatePipe],
})
export class DataManagementModule {}
